import styled, { keyframes } from "styled-components";

interface StudyBarStyleProps {
  $shade?: boolean;
  $current?: number;
}

export const BarChartMove = (width: number | undefined) => keyframes`
  0% {
      width: 0px 
    }

  100% {
      width: ${width}%;
    }
`;

export const BarMaxBox = styled.div<StudyBarStyleProps>`
  position: relative;
  width: 100%;
  height: 6px;
  background: ${(props) =>
    props.$shade === true
      ? props.theme.colors.black5
      : props.theme.colors.white100};
  border-radius: 5px;
`;

export const BarCurrent = styled.div<StudyBarStyleProps>`
  position: relative;
  height: 6px;
  left: 0;
  top: 0;
  background: ${(props) => props.theme.colors.primary100};
  border-radius: 5px;
  z-index: 1;
  animation: 1s ease-in-out ${(props) => BarChartMove(props.$current)} forwards;
`;
